
const getters = {
  shipping: (state, getters) => _.get(getters.orderData, 'shipping', {})
}

export default {
  getters
}
